export const navigation = {
  userShop: [
    {
      id: 1,
      routeName: "landingPage1",
      text: "Inicio",
      count: true,
      subItem: [],
    },
    {
      id: 2,
      routeName: "promo1",
      text: "Conoce el club",
      count: true,
      subItem: [
        {
          id: 3,
          routeName: "club1",
          text: "¿Qué es el club?",
        },
        {
          id: 4,
          routeName: "registerCodesP",
          text: "¿Cómo registrar códigos?",
        },
        // {
        //   id: 5,
        //   routeName: "promo1",
        //   text: "Promo Te Lleva a España",
        // },
        {
          id: 5,
          routeName: "contact1",
          text: "Contáctanos",
        },
        // {
        //   id: 7,
        //   routeName: "login",  
        //   text: "Ingresar códigos",
        // },
        {
          id: 6,
          routeName: "frequentQuestionsP",
          text: "Preguntas frecuentes",
        },
      ],
    },
  ],
    // {
    //   id: 7,
    //   routeName: "catalogue1",
    //   text: "Catálogo",
    //   count: true,
    //   subItem: [
    //     // {
    //     //   id: 8,
    //     //   routeName: "catalogueEcommerce",
    //     //   text: "Premios digitales",
    //     // },
    //     // {
    //     //   id: 9,
    //     //   routeName: "catalogue1",
    //     //   text: "Accesorios para motos",
    //     // },
    //     // {
    //     //   id: 10,
    //     //   routeName: "catalogueCom1",
    //     //   text: "Bonos",
    //     // },
    //     // {
    //     //   id: 11,
    //     //   routeName: "frequentQuestionsP",
    //     //   text: "Preguntas frecuentes",
    //     // },
    //   ],
    // },
  userShop2: [
    // {
    //   id: 8,
    //   routeName: "alliances1",
    //   text: "Alianzas",
    //   count: true,
    //   subItem: [],
    // },
    {
      id: 7,
      routeName: "profileUser",
      text: "Hola ",
      count: true,
      name: true,
      subItem: [],
    },
    {
      id: 8,
      routeName: "userCard",
      text: "",
      count: true,
      icon: true,
      subItem: [],
    },
  ],
  userLibricator: [
    {
      id: 9,
      routeName: "landingPage1",
      text: "Inicio",
      count: true,
      subItem: [],
    },
    {
      id: 10,
      routeName: "promo1",
      text: "Conoce el club",
      count: true,
      subItem: [
        {
          id: 11,
          routeName: "club1",
          text: "¿Qué es el club?",
        },
        {
          id: 12,
          routeName: "registerCodesP",
          text: "¿Cómo registrar códigos?",
        },
        // {
        //   id: 5,
        //   routeName: "promo1",
        //   text: "Promo Te Lleva a España",
        // },
        {
          id: 13,
          routeName: "contact1",
          text: "Contáctanos",
        },
        // {
        //   id: 4,
        //   routeName: "login",
        //   text: "Ingresar códigos",
        // },
        {
          id: 14,
          routeName: "frequentQuestionsP",
          text: "Preguntas frecuentes",
        },
      ],
    },
    // {
    //   id: 17,
    //   routeName: "catalogue1",
    //   text: "Catálogo",
    //   count: true,
    //   subItem: [
    //     // {
    //     //   id: 8,
    //     //   routeName: "catalogueEcommerce",
    //     //   text: "Premios digitales",
    //     // },
    //     // {
    //     //   id: 9,
    //     //   routeName: "catalogue1",
    //     //   text: "Accesorios para motos",
    //     // },
    //     // {
    //     //   id: 10,
    //     //   routeName: "catalogueCom1",
    //     //   text: "Bonos",
    //     // },
    //     // {
    //     //   id: 11,
    //     //   routeName: "frequentQuestionsP",
    //     //   text: "Preguntas frecuentes",
    //     // },
    //   ],
    // },
    // {
    //   id: 18,
    //   routeName: "alliances1",
    //   text: "Alianzas",
    //   count: true,
    //   subItem: [],
    // },
    // {
    //   id: 19,
    //   routeName: "lubricatorProfile",
    //   text: "Hola ",
    //   count: true,
    //   name: true,
    //   subItem: [],
    // },
    // {
    //   id: 20,
    //   routeName: "userCard",
    //   text: "",
    //   count: true,
    //   icon: true,
    //   subItem: [],
    // },
  ],
  userLibricator2: [
    // {
    //   id: 18,
    //   routeName: "alliances1",
    //   text: "Alianzas",
    //   count: true,
    //   subItem: [],
    // },
    {
      id: 15,
      routeName: "lubricatorProfile",
      text: "Hola ",
      count: true,
      name: true,
      subItem: [],
    },
    {
      id: 16,
      routeName: "userCard",
      text: "",
      count: true,
      icon: true,
      subItem: [],
    },
  ],
  userComercial: [
    {
      id: 17,
      routeName: "pointsOfSale",
      text: "Puntos de venta",
      subItem: [],
    },
    {
      id: 18,
      routeName: "dashboardDistributor",
      text: "Dashboard",
      count: true,
      // name: true,
      subItem: [
        {
          id: 19,
          routeName: "dashBiker",
          text: "Moteros",
        },
        {
          id: 20,
          routeName: "dashLub",
          text: "Lubricadores",
        },
      ],
      // style: {
      //   color: "#dc3545",
      //   margin: "0px 10px"
      // }
    },
    {
      id: 21,
      routeName: "comercialProfile",
      text: "Hola ",
      count: true,
      name: true,
      subItem: [],
    },
  ],
  userAdmin: [
    {
      id: 22,
      routeName: "adminCrm",
      text: "CRM Havoline",
      count: true,
      name: false,
      subItem: [],
    },
    {
      id: 23,
      routeName: "adminL",
      text: "Lubricadores",
      count: true,
      name: false,
      subItem: [],
    },
    {
      id: 24,
      routeName: "listPromo",
      text: "Bonos",
      count: true,
      name: false,
      subItem: [
        // {
        //   id: 24,
        //   routeName: "listPromo",
        //   text: "Promocionales",
        // },
        // {
        //   id: 25,
        //   routeName: "listGifting",
        //   text: "Eventos",
        // },
        {
          id: 25,
          routeName: "promotions",
          text: "Promoción",
        },
      ],
    },
    {
      id: 26,
      routeName: "adminQuestion1",
      text: "Gestionar",
      count: true,
      name: true,
      subItem: [
        {
          id: 27,
          routeName: "adminQuestion1",
          text: "Preguntas frecuentes",
        },
        {
          id: 28,
          routeName: "adminBanner1",
          text: "Banner",
        },
        {
          id: 29,
          routeName: "adminAlianzas",
          text: "Alianzas",
        },
        {
          id: 30,
          routeName: "adminDocuments1",
          text: "Documentos",
        },
        {
          id: 31,
          routeName: "adminProducts",
          text: "Productos",
        },
        {
          id: 32,
          routeName: "adminHistory",
          text: "Historial",
        },
        {
          id: 33,
          routeName: "updateDataOrRegister",
          text: "Links",
        },
        {
          id: 34,
          routeName: "listHavoblog",
          text: "Havoblog",
        },
        {
          id: 35,
          routeName: "listProducts",
          text: "Sección Productos",
        },
        {
          id: 36,
          routeName: "listPOS",
          text: "Puntos de venta",
        },
      ],
    },
    {
      id: 37,
      routeName: "listUser",
      text: "Usuarios",
      count: true,
      name: false,
      subItem: [],
    },
  ],
  userAdminCrm: [
    {
      id: 38,
      routeName: "adminCrm",
      text: "CRM Havoline",
      count: true,
      name: false,
      subItem: [],
      style: {
        margin: "0px 20px"
      }
    },
  ],
  userPointOfSale: [
    {
      id: 39,
      routeName: "pointOfsaleProfile",
      text: "Hola ",
      count: true,
      name: true,
      subItem: [],
    },
    {
      id: 40,
      routeName: "userCard",
      text: "",
      count: true,
      icon: true,
      subItem: [],
    },
  ],
};